/*! @pentacode/ui v0.1.0 */
import { a as e, d as t, i as n, x as r } from "./guide-layout-CrWsmVuf.js";
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/crosshair-resolver.js
function i(e) {
	let { scene: t, guide: n, focus: r, cursor: i } = e, o = a(n, r, i);
	return o ? d(t, n, o) : void 0;
}
function a(e, t, n) {
	let r = t ? {
		x: t.primary.x,
		y: t.primary.y,
		xValue: o(t.primary, "x"),
		yValue: o(t.primary, "y"),
		xCursorValue: t.primary.xValue,
		yCursorValue: t.primary.yValue,
		color: t.primary.color
	} : void 0;
	if (!n) return r;
	if (!r && (n.state.anchor === "value" ? !s(n, e) : !l(n, e))) return;
	let i = c("x", e, n, r?.x, r?.xValue, r?.xCursorValue), a = c("y", e, n, r?.y, r?.yValue, r?.yCursorValue);
	if (i || a) return {
		x: i?.position,
		y: a?.position,
		xValue: i?.value,
		yValue: a?.value,
		color: r?.color
	};
}
function o(e, t) {
	let n = t === "x" ? e.xInterval : e.yInterval, r = t === "x" ? e.x2Value : e.y2Value, i = t === "x" ? e.xValue : e.yValue;
	return n === "difference" && r !== void 0 ? r : i;
}
function s(e, t) {
	if (e.state.anchor !== "value") return !1;
	let n = e.state.value;
	return ["x", "y"].every((r) => {
		if (e.axes !== "xy" && e.axes !== r) return !0;
		let i = n[r];
		if (i === void 0) return !0;
		let a = r === "x" ? t.projectX : t.projectY, o = a ? a(i) : e[r]?.position;
		return typeof o == "number" && Number.isFinite(o) && u(t, r, o);
	});
}
function c(e, t, n, i, a, o) {
	let s = n.axes === "xy" || n.axes === e, c = n[e];
	if (s && n.state.anchor === "value") {
		let s = n.state.value[e];
		if (s !== void 0 && o !== void 0 && r(s) === r(o) && typeof i == "number" && Number.isFinite(i)) return {
			position: i,
			value: a
		};
		let l = e === "x" ? t.projectX : t.projectY, d = s === void 0 ? void 0 : l?.(s);
		if (typeof d == "number" && Number.isFinite(d) && u(t, e, d)) return {
			position: d,
			value: s
		};
		if (!l && c && Number.isFinite(c.position) && u(t, e, c.position)) return {
			position: c.position,
			value: c.value ?? s
		};
	} else if (s && c) return {
		position: c.position,
		value: c.value
	};
	return typeof i == "number" && Number.isFinite(i) ? {
		position: i,
		value: a
	} : void 0;
}
function l(e, t) {
	return ["x", "y"].every((n) => {
		if (e.axes !== "xy" && e.axes !== n) return !0;
		let r = e[n];
		return !r || u(t, n, r.position);
	});
}
function u(e, t, n) {
	let r = t === "x" ? e.chart.x : e.chart.y, i = t === "x" ? e.chart.width : e.chart.height;
	return n >= r && n <= r + i;
}
function d(t, n, r) {
	let { x: i, y: a } = r, o = [], s = [];
	if (n.x && typeof i == "number" && Number.isFinite(i)) {
		let e = i;
		if (n.x.band) {
			let t = f(n, "x", r.xValue, i);
			e = t;
			let a = Math.max(0, n.x.band.bandwidth - n.x.band.inset * 2);
			a > 0 && o.push({
				kind: "rect",
				key: `${n.key}:x-band`,
				className: "ts-chart__crosshair-band ts-chart__crosshair-band--x",
				x: t - n.x.band.bandwidth / 2 + n.x.band.inset,
				y: n.chart.y,
				width: a,
				height: n.chart.height,
				radius: n.x.band.radius,
				style: n.x.band.style
			});
		} else o.push({
			kind: "rule",
			key: `${n.key}:x-rule`,
			className: "ts-chart__crosshair-rule ts-chart__crosshair-rule--x",
			x1: i,
			x2: i,
			y1: n.chart.y,
			y2: n.chart.y + n.chart.height,
			style: n.x.style
		});
		n.x.label && r.xValue !== void 0 && s.push(...p(h({
			kind: "label",
			key: `${n.key}:x-label`,
			className: "ts-chart__crosshair-label ts-chart__crosshair-label--x",
			x: e,
			y: n.chart.y + n.chart.height + n.x.label.offset + n.x.label.fontSize * .8,
			text: m(t, "x", r.xValue, n.x.label.format),
			anchor: "middle",
			fontSize: n.x.label.fontSize,
			fontWeight: n.x.label.fontWeight,
			style: n.x.label.style
		}, n.surface, n)));
	}
	if (n.y && typeof a == "number" && Number.isFinite(a)) {
		let i = a;
		if (n.y.band) {
			let e = f(n, "y", r.yValue, a);
			i = e;
			let t = Math.max(0, n.y.band.bandwidth - n.y.band.inset * 2);
			t > 0 && o.push({
				kind: "rect",
				key: `${n.key}:y-band`,
				className: "ts-chart__crosshair-band ts-chart__crosshair-band--y",
				x: n.chart.x,
				y: e - n.y.band.bandwidth / 2 + n.y.band.inset,
				width: n.chart.width,
				height: t,
				radius: n.y.band.radius,
				style: n.y.band.style
			});
		} else o.push({
			kind: "rule",
			key: `${n.key}:y-rule`,
			className: "ts-chart__crosshair-rule ts-chart__crosshair-rule--y",
			x1: n.chart.x,
			x2: n.chart.x + n.chart.width,
			y1: a,
			y2: a,
			style: n.y.style
		});
		n.y.label && r.yValue !== void 0 && s.push(...p(h({
			kind: "label",
			key: `${n.key}:y-label`,
			className: "ts-chart__crosshair-label ts-chart__crosshair-label--y",
			x: n.chart.x - n.y.label.offset,
			y: i,
			text: m(t, "y", r.yValue, n.y.label.format),
			anchor: e("right", n.direction),
			baseline: "middle",
			fontSize: n.y.label.fontSize,
			fontWeight: n.y.label.fontWeight,
			style: n.y.label.style
		}, n.surface, n)));
	}
	if (n.marker && typeof i == "number" && Number.isFinite(i) && typeof a == "number" && Number.isFinite(a) && o.push({
		kind: "dot",
		key: `${n.key}:marker`,
		className: "ts-chart__crosshair-marker",
		x: i,
		y: a,
		radius: n.marker.radius,
		style: {
			...n.marker.style,
			stroke: n.marker.style.stroke ?? r.color ?? n.x?.style.stroke ?? n.y?.style.stroke ?? t.theme.foreground
		}
	}), o.length && s.unshift({
		kind: "group",
		key: `${n.key}:plot`,
		className: "ts-chart__crosshair-plot",
		clip: n.chart,
		children: o
	}), s.length) return {
		kind: "group",
		key: n.key,
		className: "ts-chart__crosshair",
		ariaHidden: !0,
		children: s
	};
}
function f(e, t, n, r) {
	let i = t === "x" ? e.projectX : e.projectY, a = n === void 0 ? void 0 : i?.(n);
	return typeof a == "number" && Number.isFinite(a) ? a : r;
}
function p(e) {
	let t = e.style ?? {};
	return [...t.stroke && (t.strokeWidth ?? 0) > 0 && t.strokeOpacity !== 0 ? [{
		...e,
		key: `${e.key}:halo`,
		className: `${e.className ?? ""} ts-chart__crosshair-label-halo`.trim(),
		style: {
			fill: "none",
			stroke: t.stroke,
			strokeOpacity: t.strokeOpacity,
			strokeWidth: t.strokeWidth,
			opacity: t.opacity,
			lineJoin: "round"
		}
	}] : [], {
		...e,
		key: `${e.key}:text`,
		className: `${e.className ?? ""} ts-chart__crosshair-label-text`.trim(),
		style: {
			fill: t.fill,
			fillOpacity: t.fillOpacity,
			stroke: "none",
			strokeWidth: 0,
			opacity: t.opacity
		}
	}];
}
function m(e, t, n, i) {
	if (i) return i(n);
	let a = r(n), o = e.scales[t]?.ticks.find((e) => r(e.value) === a);
	return o ? o.label : n instanceof Date ? n.toLocaleDateString() : String(n);
}
function h(e, t, r) {
	let i = n(e, r.measureText), a = t.x + 2, o = t.y + 2, s = t.x + t.width - 2, c = t.y + t.height - 2, l = i.x < a ? a - i.x : i.x + i.width > s ? s - i.x - i.width : 0, u = i.y < o ? o - i.y : i.y + i.height > c ? c - i.y - i.height : 0;
	return l || u ? {
		...e,
		x: e.x + l,
		y: e.y + u
	} : e;
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/crosshair.js
function g(e = {}) {
	let n = e.xScale ?? "x", r = e.yScale ?? "y";
	return t(({ markIndex: t }) => {
		let a = e.id ?? `crosshair-${t}`;
		return {
			id: a,
			focusGuideOnly: !0,
			channels: {
				x: {
					scale: n,
					values: []
				},
				y: {
					scale: r,
					values: []
				}
			},
			render: ({ chart: t, surface: o, scales: s, theme: c, layout: l }) => ({
				nodes: [],
				focusGuides: [{
					key: a,
					markId: a,
					chart: t,
					surface: o,
					x: _(e.x, e, c.foreground, s[n]),
					y: _(e.y, e, c.foreground, s[r]),
					marker: C(e.marker),
					projectX: x(s[n]),
					projectY: x(s[r]),
					motion: e.motion,
					measureText: l.measureText,
					direction: l.typography?.direction,
					resolve: i
				}]
			})
		};
	}, e.motion, e.renderer);
}
function _(e, t, n, r) {
	if (e === !1) return;
	let i = typeof e == "object" ? e : void 0;
	return {
		style: y(t, i, n),
		label: b(i?.label, n, r),
		band: v(i?.band, n, r)
	};
}
function v(e, t, n) {
	if (!e) return;
	let r = typeof e == "object" ? e : void 0;
	return {
		bandwidth: w(n?.bandwidth, 0),
		inset: T(r?.inset, 0),
		radius: r?.radius === void 0 ? void 0 : w(r.radius, 0),
		style: {
			fill: r?.fill ?? t,
			fillOpacity: r?.fillOpacity ?? .12,
			stroke: r?.stroke,
			strokeOpacity: r?.strokeOpacity,
			strokeWidth: r?.strokeWidth === void 0 ? void 0 : w(r.strokeWidth, 0),
			opacity: r?.opacity
		}
	};
}
function y(e, t, n) {
	return {
		stroke: t?.stroke ?? e.stroke ?? n,
		strokeOpacity: t?.strokeOpacity ?? e.strokeOpacity ?? .35,
		strokeWidth: w(t?.strokeWidth ?? e.strokeWidth, 1),
		strokeDasharray: t?.strokeDasharray ?? e.strokeDasharray
	};
}
function b(e, t, n) {
	if (!e) return;
	let r = typeof e == "object" ? e : void 0;
	return {
		format: r?.format ? (e) => r.format(e) : n ? (e) => S(n, e) : void 0,
		offset: w(r?.offset, 8),
		fontSize: w(r?.fontSize, 11),
		fontWeight: r?.fontWeight,
		style: {
			fill: r?.fill ?? t,
			fillOpacity: r?.fillOpacity,
			stroke: r?.stroke ?? "var(--ts-chart-crosshair-label-halo, Canvas)",
			strokeOpacity: r?.strokeOpacity,
			strokeWidth: w(r?.strokeWidth, 3),
			opacity: r?.opacity
		}
	};
}
function x(e) {
	return e && e.type !== "none" ? (t) => {
		let n = (e.viewport?.map ?? e.map)(t);
		return Number.isFinite(n) ? n : void 0;
	} : void 0;
}
function S(e, t) {
	let n = r(t), i = e.ticks.find((e) => r(e.value) === n);
	return i ? i.label : t instanceof Date ? t.toLocaleDateString() : String(t);
}
function C(e) {
	if (!e) return;
	let t = typeof e == "object" ? e : void 0;
	return {
		radius: w(t?.radius, 4),
		style: {
			fill: t?.fill ?? "var(--ts-chart-crosshair-marker-fill, Canvas)",
			fillOpacity: t?.fillOpacity,
			stroke: t?.stroke,
			strokeOpacity: t?.strokeOpacity,
			strokeWidth: w(t?.strokeWidth, 2),
			opacity: t?.opacity
		}
	};
}
function w(e, t) {
	return typeof e == "number" && Number.isFinite(e) && e >= 0 ? e : t;
}
function T(e, t) {
	return typeof e == "number" && Number.isFinite(e) ? e : t;
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/mark-decorative-internal.js
function E(e, t, n) {
	return {
		motion: e.motion,
		renderer: e.renderer,
		initialize(r) {
			let i = e.initialize(r);
			D(i, i.id, n);
			let { focus: a, states: o, resolveLayout: s, ...c } = i;
			return {
				...O(c, n.layoutLabels),
				render: i.render,
				postDomain: k(i.postDomain, t, i),
				...s ? { resolveLayout(e) {
					let r = s(e);
					D(r, i.id, n);
					let { states: a, ...o } = r;
					return {
						...O(o, n.layoutLabels),
						render: r.render,
						postDomain: k(r.postDomain ?? i.postDomain, t, {
							id: i.id,
							states: r.states ?? i.states
						})
					};
				} } : {}
			};
		}
	};
}
function D(e, t, n) {
	if (n.conditional !== "remove" && (e.focus !== void 0 || n.conditional === "reject" && e.states !== void 0)) throw TypeError(`decorative() cannot wrap mark "${t}" with focus or state behavior`);
}
function O(e, t) {
	if (t === "preserve") return e;
	let { layoutLabels: n, ...r } = e;
	return r;
}
function k(e, t, n) {
	return (r) => t(e ? e(r) : r, n);
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/mark-scene-filter-internal.js
function A(e, t = {}) {
	return {
		nodes: e.nodes.map((e) => j(e, t.conditional ?? "remove")),
		points: []
	};
}
function j(e, t) {
	if (e.kind === "group") {
		if (t !== "remove" && (e.focus || t === "reject" && e.states)) throw TypeError("decorative() cannot wrap scene geometry with focus or state behavior");
		let n = e.focus?.retarget && e.focus.candidates ? e.focus.candidates : e.children, { focus: r, states: i, pointOwner: a, pointOwners: o, focusCandidateIndex: s, ...c } = e;
		return {
			...c,
			...t === "preserve-states" && i ? { states: i } : {},
			...t === "preserve-states" && a ? { pointOwner: a } : {},
			...t === "preserve-states" && o ? { pointOwners: o } : {},
			children: n.map((e) => j(e, t))
		};
	}
	if (e.kind === "label") {
		let { pointOwner: n, pointOwners: r, ...i } = e;
		return t === "preserve-states" ? e : i;
	}
	let { interaction: n, pointOwner: r, pointOwners: i, ...a } = e;
	return t === "preserve-states" ? {
		...a,
		...r || n?.point ? { pointOwner: r ?? n?.point } : {},
		...i || n?.points ? { pointOwners: i ?? n?.points } : {}
	} : a;
}
function M(e) {
	let t = e.points ? [...e.points] : [], n = new Set(t), r = (e) => {
		for (let r of e) {
			let e = r;
			n.has(e) || (n.add(e), t.push(e));
		}
	}, i = (e) => {
		for (let t of e) {
			if (t.pointOwner && r([t.pointOwner]), t.pointOwners && r(t.pointOwners), t.kind === "group") {
				t.focus && (r(t.focus.points), t.focus.activePoints && r(t.focus.activePoints), t.focus.candidates && i(t.focus.candidates)), t.states && r(t.states.points), i(t.children);
				continue;
			}
			if (t.kind === "label" || !t.interaction) continue;
			let e = t.interaction.point ? [t.interaction.point] : t.interaction.points;
			r(e);
		}
	};
	return i(e.nodes), t;
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/mark-decorative.js
function N(e) {
	return E(e, (e, { id: t, states: n }) => A(n ? {
		...e,
		nodes: [{
			kind: "group",
			key: `states:${t}`,
			children: e.nodes,
			states: {
				...n,
				points: M(e)
			}
		}]
	} : e, { conditional: "preserve-states" }), {
		conditional: "preserve-states",
		layoutLabels: "preserve"
	});
}
//#endregion
export { g as n, N as t };

//# sourceMappingURL=mark-decorative-DmSkufit.js.map